import styled from 'styled-components';

const Container = styled.div`
    width:100%;
    height: 100vh;
    overflow-y: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background: transparent;
        border-radius: 5px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }
`;


const Wrapper = styled.div`
    width: calc(100% - 40px);
    margin-left: 20px;
`;


export { Container, Wrapper };